import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'
import type {
	CodeDelivery,
	CodeDeliveryModel,
	CodeDeliveryStorePayload,
	CodeDeliveryUpdatePayload,
} from './Model'
import Api from '@/helpers/models/Api'
import type { Build } from '@/models/Build/Model'
import type { RepositoryConfig } from '@/models/RepositoryConfig/Model'
import type { AxiosResponse } from 'axios'
import axios from 'axios'

const apiUrl = import.meta.env.VITE_API_URL

export default class CodeDeliveriesApi extends Api<
	CodeDeliveryModel,
	LaravelPaginationResponse<CodeDeliveryModel>,
	CodeDeliveryStorePayload,
	CodeDeliveryUpdatePayload
> {
	route = 'code_deliveries'

	async update(): Promise<any> {
		throw new Error('Not implemented')
	}

	async updateRelation(): Promise<any> {
		throw new Error('Not implemented')
	}

	async destroy(): Promise<any> {
		throw new Error('Not implemented')
	}

	async store(): Promise<any> {
		throw new Error('Not implemented')
	}

	async deliver(params: {
		build_id: Build['id']
		delivery:
			| {
					type: 'git'
					repository_config_id: RepositoryConfig['id']
			  }
			| {
					type: 'zip'
			  }
	}): Promise<AxiosResponse<{ delivery: CodeDelivery }>> {
		return await axios.post(`${apiUrl}/${this.route}`, params)
	}
}
